import plusIcon from "../../assets/design-revamp/plus-icon.svg";

const PlusIcon = ({ style, onClick }) => {
  return (
    <>
      <div onClick={onClick}>
        <img
          className=""
          src={plusIcon}
          alt=""
          style={{ ...style, width: "20px", height: "20px" }}
        />
      </div>
    </>
  );
};

export default PlusIcon;
